<h2>Artículos</h2>
<!--Table-->
<div class="card">

  <form [formGroup]="searchForm" (ngSubmit)="search()" class="mb-4 gap-2 p-4 surface-card shadow-2 border-round ">
    <div class="formgroup-inline">

      <div class="field col-12 xl:col-2">
        <label for="warehouse" class="block font-bold mb-2">Bodega</label>
        <p-select id="warehouse" optionLabel="name" optionValue="name" formControlName="warehouse"
          [options]="warehouses" placeholder="Selecciona una bodega" optionLabel="name"
        [fluid]="true"></p-select>
      </div>

      <div class="field col-12 xl:col-3">
        <label for="category" class="block font-bold mb-2">Cuenta</label>
        <p-select [options]="accounts" formControlName="accountId" placeholder="Selecciona una cuenta"
          optionLabel="name" [resetFilterOnHide]="true" [filter]="true" lazy="true"
          (onFilter)="loadAccounts($event)" [showClear]="true" placeholder="Selecciona una Cuenta"
          optionValue="accountId" [disabled]="!hasAccountAccess" [loading]="accountLoading" [fluid]="true" autofocus
          [appendTo]="'body'">
        </p-select>
      </div>

      <div class="field col-12 xl:col-2">
        <label for="code" class="block font-bold mb-2">Código de Artículo</label>
        <p-iconField class="w-full">
          <p-inputIcon class="pi pi-code" />
          <input pInputText id="code" maxlength="15" formControlName="code" placeholder="Buscar por Código"
            class="w-full">
        </p-iconField>
      </div>

      <div class="field col-12 xl:col-4">
        <label for="description" class="block font-bold mb-2">Descripción</label>
        <p-iconField class="w-full">
          <p-inputIcon class="pi pi-search" />
          <input pInputText id="description" maxlength="60" formControlName="description"
            placeholder="Buscar por Descripción" class="w-full">
        </p-iconField>
      </div>

      <div class="field col-12 xl:col-2">
        <label for="code" class="block font-bold mb-2">SKU</label>
        <p-iconField class="w-full">
          <p-inputIcon class="pi pi-barcode" />
          <input pInputText id="serialNumber" maxlength="30" formControlName="serialNumber"
            placeholder="Buscar por SKU" class="w-full">
        </p-iconField>
      </div>

      <div class="field col-12 xl:col-2">
        <label for="status" class="block font-bold mb-2">Estado</label>
        <p-multiSelect formControlName="status" [options]="statuses" [filter]="false"
          placeholder="Selecciona Estado(s)" display="chip" showClear [fluid]="true">
          <ng-template let-option pTemplate="item">
            <p-tag [value]="option.value" [severity]="getSeverity(option.label)" />
          </ng-template>
        </p-multiSelect>
      </div>

      <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus" value="-1">
        <p-accordion-panel value="0">
          <p-accordion-header>
            <span class="flex align-items-center gap-2 w-full">
              <span class="font-bold white-space-nowrap">
                Búsqueda Avanzada
              </span>
            </span>
          </p-accordion-header>
          <p-accordion-content>
            <div class="formgroup-inline">
              <div class="field col-12 xl:col-2">
                <label for="palletCode" class="block font-bold mb-2">Código de Palet</label>
                <p-iconField class="w-full">
                  <p-inputIcon class="pi pi-code" />
                  <input pInputText id="palletCode" formControlName="palletCode"
                    placeholder="Buscar por Código de Pallet" class="w-full">
                </p-iconField>
              </div>

              <div class="field col-12 xl:col-2">
                <label for="creationDateFrom" class="block font-bold mb-2">Fecha de Creación Desde</label>
                <p-datepicker id="creationDateFrom" formControlName="creationDateFrom" dateFormat="dd/mm/yy"
                [appendTo]="'body'" showIcon></p-datepicker>
              </div>

              <div class="field col-12 xl:col-2">
                <label for="creationDateTo" class="block font-bold mb-2">Fecha de Creación Hasta</label>
                <p-datepicker id="creationDateTo" formControlName="creationDateTo" dateFormat="dd/mm/yy"
                [appendTo]="'body'" showIcon></p-datepicker>
              </div>

            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>

    </div>

    <div class="flex justify-content-end gap-2 mt-4">
      <button pButton type="submit" label="Buscar" icon="pi pi-search" severity="primary"></button>
      <button pButton type="button" label="Limpiar" icon="pi pi-times" severity="secondary"
      (click)="resetForm()"></button>
    </div>
  </form>

  <p-popover #overlay [style]="{width:'300px'}">
    <div class="dropdown-header">
      <div class="dropdown-header-left">
        <p-checkbox [(ngModel)]="selectAll" binary="true" (onChange)="onSelectAll($event)">
        </p-checkbox>
        <input type="text" pInputText placeholder="Buscar Columna" [(ngModel)]="searchTerm"
          class="column-search-input">
      </div>
      <button pButton icon="pi pi-times" (click)="overlay.hide()" class="p-button-rounded p-button-text">
      </button>
    </div>
    <br>
      <div class="columns-list mb-2" style="max-height:200px; overflow:auto;">
        @for (col of filteredColumns; track col) {
          <div>
            @if (!col.alwaysVisible) {
              <div class="field-checkbox">
                <p-checkbox [(ngModel)]="col.visible" binary="true" [inputId]="'col-' + col.field"
                  (onChange)="onColumnToggle()" />
                <label [for]="'col-' + col.field">{{ col.header }}</label>
              </div>
            }
          </div>
        }
      </div>
      <div class="footer flex justify-content-end gap-2">
        <button pButton label="Limpiar" severity="secondary" (click)="onClearColumns()"></button>
        <button pButton label="Guardar" (click)="onSaveColumns(); overlay.hide()"></button>
      </div>
    </p-popover>

    <p-table [value]="items" dataKey="itemId" [paginator]="true" [rows]="tableRows"
      [rowsPerPageOptions]="[30, 50, 100, 200]" [totalRecords]="totalRecords" [lazy]="true"
      (onLazyLoad)="loadItems($event)" [loading]="loading" [responsiveLayout]="'scroll'" [(first)]="firstPage"
      [sortOrder]="-1" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando del {first} al {last} de {totalRecords} Registros"
      styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between mb-2">
          <div class="flex align-items-center gap-3">
            <span>Total página actual —</span>
            <span><b>Recibidos:</b> {{ totalUnits }}</span>
            <p-divider layout="vertical" />
            <span><b>En Stock:</b> {{ totalStock }}</span>
          </div>
          <div class="flex gap-2">
            <p-button icon="pi pi-download" severity="secondary" pTooltip="Exportar Excel"
              (click)="exportExcel()">
            </p-button>
            <p-button icon="pi pi-map" (click)="overlay.toggle($event); onColumnToggle()"
              pTooltip="Mostrar Columnas">
            </p-button>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          @for (col of appliedTableColumns; track col) {
            <th [pSortableColumn]="col.sortable ? col.field : ''">
              {{ col.header }}
              @if (col.sortable) {
                <p-sortIcon [field]="col.field" />
              }
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
        <tr>
          @for (col of appliedTableColumns; track col) {
            <td>
              @switch (col.type) {
                <!-- Number / itemId -->
                @case ('number') {
                  <span>
                    {{ col.field === 'itemId' ? rowIndex + 1 : resolveField(item, col.field) }}
                  </span>
                }
                <!-- String -->
                @case ('string') {
                  <span>
                    {{ resolveField(item, col.field) }}
                  </span>
                }
                <!-- Date -->
                @case ('date') {
                  <span>
                    {{ resolveField(item, col.field) | date:'dd/MMM/yyyy h:mm a' }}
                  </span>
                }
                <!-- Tag -->
                @case ('tag') {
                  <span>
                    <p-tag [value]="resolveField(item, col.field)"
                      [severity]="getSeverity(resolveField(item, col.field))">
                    </p-tag>
                  </span>
                }
                <!-- Actions -->
                @case ('actions') {
                  <span>
                    <div class="flex gap-2 justify-content-center">
                      <button [disabled]="!item?.updateDate" pButton icon="pi pi-history" severity="info"
                        class="p-button-rounded p-button-xs" pTooltip="Historial"
                        (click)="showHistory(item)" style="width: 30px; height: 30px; padding: 0;">
                      </button>
                      @if (hasDeleteAccess) {
                        <button [disabled]="item.status !== 'RECIBIDO'" pButton
                          icon="pi pi-trash" severity="danger" class="p-button-rounded p-button-xs"
                          pTooltip="Eliminar" (click)="deleteItem(item)"
                          style="width: 30px; height: 30px; padding: 0;">
                        </button>
                      }
                    </div>
                  </span>
                }
              }
            </td>
          }
        </tr>
      </ng-template>


      <ng-template pTemplate="summary">
        <div class="flex align-items-center gap-3">
          <span>Total página actual —</span>
          <span><b>Recibidos:</b> {{ totalUnits }}</span>
          <p-divider layout="vertical" />
          <span><b>En Stock:</b> {{ totalStock }}</span>
        </div>
      </ng-template>
    </p-table>
  </div>

  <!-- Dialog to show item movements-->
  <p-dialog header="Historial de movimientos {{ this.selectedItem?.code }}" [(visible)]="historyDialogVisible"
    [style]="{width: '500px'}" [modal]="true" contentStyleClass="movements-dialog-content">
    <div class="stat-panel">
      <div class="stat-tile">
        <span class="stat-icon"><i class="pi pi-box"></i></span>
        <span class="stat-label">Cantidad inicial</span>
        <span class="stat-value">{{ this.selectedItem?.startQuantity }}</span>
      </div>
      <p-divider layout="vertical" />
      <div class="stat-tile">
        <span class="stat-icon"><i class="pi pi-arrow-down-left"></i></span>
        <span class="stat-label">Total recibidos</span>
        <span class="stat-value">{{ this.selectedItem?.initialQuantity }}</span>
      </div>
      <p-divider layout="vertical" />
      <div class="stat-tile">
        <span class="stat-icon"><i class="pi pi-verified"></i></span>
        <span class="stat-label">En stock</span>
        <span class="stat-value">{{ this.selectedItem?.quantity }}</span>
      </div>
    </div>

    <div class="movements-scroll">
      <p-timeline [value]="movements" align="left" styleClass="movements-timeline">

        <ng-template pTemplate="marker" let-movement>
          <span class="movement-marker"
            [ngClass]="movement.movementType === 'RELEASE' ? 'movement-marker-release' : 'movement-marker-update'">
            <i class="pi"
            [ngClass]="movement.movementType === 'RELEASE' ? 'pi-arrow-up-right' : 'pi-pencil'"></i>
          </span>
        </ng-template>

        <ng-template pTemplate="content" let-movement>
          <div class="movement-card">
            <div class="movement-card-header">
              <span class="movement-title">
                @if (movement.movementType === 'RELEASE') {
                  Salida de {{ movement.quantity
                  }}
                }
                @if (movement.movementType === 'UPDATE') {
                  Edición
                }
              </span>
              <small class="text-surface-500 dark:text-surface-400">{{ (movement.movementTime ||
              movement.creationTime) | date:'dd/MMM/yyyy h:mm a' }}</small>
            </div>

            @if (movement.movementType === 'UPDATE') {
              <div class="movement-card-body">
                @for (field of movement.changeDetail | keyvalue; track field) {
                  <div class="movement-change">
                    <span class="movement-change-label">{{ getFieldLabel($any(field.key)) }}:</span>
                    <span class="movement-change-value">"{{ getFieldValue($any(field.key),
                      $any(field.value)?.old)
                    }}" → "{{ getFieldValue($any(field.key), $any(field.value)?.new) }}"</span>
                  </div>
                }
              </div>
            }

            <div class="movement-card-footer">
              <small class="text-surface-500 dark:text-surface-400">por {{ movement.user }}</small>
              @if (movement.movementReason) {
                <div class="movement-reason">
                  <i><strong>Nota: </strong>{{ movement.movementReason }}</i>
                </div>
              }
            </div>
          </div>
        </ng-template>

      </p-timeline>
    </div>
  </p-dialog>

  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>